import { render } from "./ChooseTaskTagType.vue?vue&type=template&id=7b78fa01&scoped=true"
import script from "./ChooseTaskTagType.vue?vue&type=script&lang=js"
export * from "./ChooseTaskTagType.vue?vue&type=script&lang=js"

import "./ChooseTaskTagType.vue?vue&type=style&index=0&id=7b78fa01&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b78fa01"]])

export default __exports__